import { ApiClient } from './client'
import { GET_ALERTS, PUT_ALERTS } from './endpoints'

export const fetchAlerts = async () => {
  const res = await ApiClient.get(GET_ALERTS)
  return res.data
}

export const updateAlert = async (id: number) => {
  const res = await ApiClient.put(PUT_ALERTS(id))
  return res.data
}
